<template>
  <footer class="site-footer">
    <div class="footer-inner">
      <div class="footer-brand">
        <span class="footer-logo">云知微</span>
        <p class="footer-copy">© 2026 WeData. All rights reserved.</p>
        <p class="footer-icp">
          <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer">浙ICP备2026040675</a>
        </p>
      </div>
      <div class="footer-links">
        <a href="#">关于我们</a>
        <router-link to="/policy/contact">联系方式</router-link>
        <router-link to="/policy/user-agreement">用户协议</router-link>
        <router-link to="/policy/privacy">隐私条款</router-link>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'SiteFooter'
}
</script>

<style scoped>
.site-footer {
  padding: 32px 24px;
  border-top: 1px solid #e5e7eb;
  background: #f9fafb;
}

.footer-inner {
  max-width: 1400px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.footer-logo {
  font-size: 16px;
  font-weight: 600;
  color: #374151;
}

.footer-copy {
  font-size: 13px;
  color: #9ca3af;
  margin-top: 4px;
}

.footer-icp {
  margin: 6px 0 0;
  font-size: 12px;
}

.footer-icp a {
  color: #9ca3af;
  text-decoration: none;
}

.footer-icp a:hover {
  color: #6b7280;
}

.footer-links {
  display: flex;
  gap: 24px;
}

.footer-links a,
.footer-links .router-link-active,
.footer-links a:visited {
  font-size: 14px;
  color: #6b7280;
  text-decoration: none;
  transition: color 0.3s;
}

.footer-links a:hover {
  color: #2563eb;
}
</style>
